
<head>
  <title>Invalid URL</title>
</head>

<body>

<div class="error-page">

  <div class="error-card">

    <h1 class="error-code">404</h1>

    <h2 class="error-title">
      Invalid URL
    </h2>

    <p class="error-message">
      The page you are trying to access does not exist or the URL is incorrect.
    </p>

  </div>

</div>

</body>